<template>
  <v-overlay class="fullscreen" opacity="0">
    <template v-if="currentChapterContent">
      <h4 class="chapter-title">{{currentChapterContent.title}}</h4>

      <v-container class="chapter-contents px-0" fluid>
        <v-row class="fullscreen-row mb-6" @click="onClick('0', '0')" :class="{'fullscreen-row--active': $root.currentChapterSection === 'chapter-quote'}">
          <v-col cols="7" md="3" offset="3" class="pt-1">
            <h2 v-translate>General Intro</h2>
          </v-col>
        </v-row>

        <v-row class="fullscreen-row my-6" v-for="(project, index) in currentChapterContent.projects" :key="index" :class="{'fullscreen-row--active': $root.currentChapterSection && $root.currentChapterSection.indexOf('project-') === 0 && parseInt( $root.currentChapterSection.split('project-')[1] ) === index}" >
          <v-col cols="7" md="3" offset="3" @click="onClick(index + 1, project.title)">
            <h6>Chapter {{chapterId}}.{{getProjectIndex(index + 1)}}</h6>
            <h4>{{project.author}}</h4>
            <h2>{{project.title}}</h2>
          </v-col>
        </v-row>
        <v-row class="fullscreen-row my-6" v-if="currentChapter.socials.length" @click="onClick('social', 'social')" :class="{'fullscreen-row--active': $root.currentChapterSection === 'chapter-social'}" >
          <v-col cols="7" md="3" offset="3">
            <h2 v-translate>Icons from Social Media</h2>
          </v-col>
        </v-row>
        <v-row class="fullscreen-row my-6" v-if="currentChapterContent.extras.length" @click="onClick('extra', 'social')" :class="{'fullscreen-row--active': $root.currentChapterSection === 'chapter-extra'}">
          <v-col cols="7" md="3" offset="3">
            <h2 v-translate>Appendix</h2>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </v-overlay>
</template>

<script>
import find from 'lodash/find'

export default {
  name: 'ProjectContents',

  props: {
    open: {
      required: true
    }
  },

  mounted () {
    document.querySelector('html').classList.toggle('application--dialog-opened', true)

    // this.currentSubChapter = this.$route.params.currentSubChapterId
  },

  destroyed () {
    document.querySelector('html').classList.toggle('application--dialog-opened', false)
  },

  methods: {
    getProjectIndex (id) {
      return (id < 10) ? '0' + id : id
    },

    onClick (id, title) {
      this.$emit('update:open', false)
      this.$events.emit('chapter-scroll-to', { id, slug: 'chapter-' + this.chapterId })
    }
  },

  computed: {
    chapterId () {
      return parseInt(this.$route.params.chapterId)
    },
    currentChapter () {
      const chapter = find(this.$root.chapters, { _slug: 'chapter-' + this.chapterId })

      return (!chapter) ? {} : chapter
    },

    currentChapterContent () {
      return (!this.currentChapter) ? {} : this.currentChapter[this.$route.params.language]
    }
  }
}
</script>

<style scoped lang="scss">

$margin-top-desktop: 160px;
$margin-top-mobile: 60px;

.fullscreen {
  background-color: $c-red;
}

.fullscreen-row {
  pointer-events: all;
  cursor: pointer;

  opacity: 0.5;
  transition: opacity 0.3s ease-out;

  &--active {
    opacity: 1;
  }

  &:hover {
    opacity: 1;
  }
}

.chapter-contents {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100%;

  position: relative;
  padding-top: $margin-top-desktop;

  @include breakpoint('sm-and-down') {
    padding-top: $margin-top-mobile;
  }

  &::before {
    content: '';
    display: table;

    position: absolute;

    top: $margin-top-desktop;
    left: 20%;
    width: 1px;
    height: 95%;
    background-color: $c-light-grey;

    @include breakpoint('sm-and-down') {
      top: $margin-top-mobile;
    }
  }
}

.chapter-title {
  top: $margin-top-desktop;
  left: 20%;
  margin-left: -30px;
  color: $c-white;
  position: absolute;
  transform-origin: right;
  transform: translateX(-100%) rotate(-90deg);

  @include breakpoint('sm-and-down') {
    top: $margin-top-mobile;
  }
}

h6 {
  font-family: 'Lora', sans-serif;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: 0.08px;
  text-align: left;
  color: $c-gradient-bg;

  @include breakpoint('md-and-up') {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: 0.14px;
    text-align: left;
  }
}

h4 {
  font-family: 'Lora', sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 0.08px;
  text-align: left;
  color: $c-gradient-bg;
  text-transform: none;

  @include breakpoint('md-and-up') {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: normal;
    text-align: left;
  }
}

h2 {
  font-family: 'Barlow', sans-serif;
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: $c-light-grey;

  @include breakpoint('md-and-up') {
    font-size: 30px;
    letter-spacing: 0;
  }
}

</style>
